import React from "react"
import { Link } from "gatsby-plugin-modal-routing-3"
import * as BreadcrumbStyles from "./Breadcrumb.module.scss"
import Section from "../main/section/Section"
import { site } from "../../../../utils/site"

const HOME_ICON_URL =
  "https://media.paritel.fr/paritel-www-dev/assets/Accueil_b4f9607a87.svg"

const BreadcrumbComponent = ({ breadcrumbs }) => {
  return (
    <Section
      className={"gc " + BreadcrumbStyles.breadcrumb}
      container="xxlarge"
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          {breadcrumbs?.map((breadcrumb, index) => (
            <li
              key={index}
              className={`breadcrumb-item${
                index === breadcrumbs.length - 1 ? " active" : ""
              }`}
              aria-current={index === breadcrumbs.length - 1 ? "page" : null}
            >
              {index === 0 ? (
                <Link to="/">
                  <img
                    src={HOME_ICON_URL}
                    alt="Accueil"
                  />
                  &nbsp;{breadcrumb.label}
                </Link>
              ) : index === breadcrumbs.length - 1 ? (
                <strong>{breadcrumb.label}</strong>
              ) : (
                <Link to={breadcrumb.url}>{breadcrumb.label}</Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </Section>
  )
}

export default BreadcrumbComponent
